module.exports = __webpack_public_path__ + "img/icon_qywx.53369cab.png";